export enum PriceType {
  PRICEABOCHECKBOXCARD = 'PRICEABOCHECKBOXCARD',
  PRICESEARCHRESULTCARD = 'PRICESEARCHRESULTCARD',
  PRICE_PDP = 'PRICE_PDP',
  PRICE_PLP_SEARCH_CARD = 'PRICE_PLP_SEARCH_CARD',
  PRICE_GCO_CARD = 'PRICE_GCO_CARD',
  PRICE_VARIANT_CARD = 'PRICE_VARIANT_CARD',
  CART_CARD_VARIANT = 'CART_CARD_VARIANT',
  CART_CARD_MOBILE_VARIANT = 'CART_CARD_MOBILE_VARIANT',
  CHECKOUT = 'CHECKOUT',
  FREE_PRODUCT_CARD = 'FREE_PRODUCT_CARD',
  PRODUCT_MERCHANDISE = 'PRODUCT_MERCHANDISE',
  PROMOTION_CARD = 'PROMOTION_CARD',
  PRICE_RANGE = 'PRICE_RANGE',
  PRICE_POST_PURCHASE = 'PRICE_POST_PURCHASE',
}
